import { db } from "../../../../dexie/db";
import { downloadDexieFile } from "../../../../utils/downloadDexieFile";

export const downLoadDexieReportfile = async (id: number, fileName: string) => {
  const data = await db.reports.get(id);
  if (!data?.robFile) {
    alert("File does not exist.");
    return;
  }
  downloadDexieFile(fileName, data.robFile);
};
